import { SchemeType } from '@/shared/types/api.types'

export const schemeBadgeMap: Record<SchemeType, string> = {
  [SchemeType.WorldwideExcl]: 'outbound.select_plan.insurance_values.plan_badge.full_cover',
  [SchemeType.FlyEurope]: 'outbound.select_plan.insurance_values.plan_badge.budget',
  [SchemeType.Worldwide]: '',
  [SchemeType.Regional]: '',
}
